export default __webpack_public_path__ + "static/media/news-bg.cbd9e118.jpg";